<template>
  <b-modal
    id="edit-folder-modal"
    name="edit-folder-modal"
    ref="editfoldermodal"
    title="Edit folder"
    size="lg"
    :busy="loading"
    ok-title="Update"
    :ok-disabled="!folderName"
    close-title="Cancel"
    hide-header-close
    @shown="shown"
    @ok="handleOk">
    <form id="update-folder-form">
      <div class="form-group">
        <b-form-input type="text"
                      placeholder="Folder name"
                      v-model="folderName"
                      data-vv-name="name"
                      v-validate="'required'">
        </b-form-input>
        <icon v-show="errors.has('name')" name="warning"></icon>
        <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
      </div>
    </form>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Updating
    </div>
  </b-modal>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        folder: null,
        folderName: '',
        loading: false
      }
    },
    props: {
      folderId: Number
    },
    mixins: [utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        // This validateAll is needed for the case when nothing has been entered yet
        // Otherwise it was letting it validate
        // The empty then/catch avoids a console error
        this.$validator.validateAll().then(() => {
        }).catch(() => {
        })
        if (this.errors.any()) {
          return e.cancel()
        } else {
          this.loading = true
          this.submitData()
        }
      },
      mounted () {
        // Ideally I'd get rid of this, but it's needed for the first time the modal is opened
        this.getFolderData()
      },
      shown () {
        this.getFolderData()
      },
      getFolderData () {
        this.$http.get(
          '/api/folder/' + this.folderId
        ).then(response => {
          this.folder = response.data.folder
          this.folderName = response.data.folder.name
        }, response => {
        })
      },
      setTheState () {
        // This potentially updates the name, so both the list and the detail need updating
        this.$store.commit('setNeedToRefreshFolderDetail', true)
        this.$store.commit('setNeedToRefreshItemsList', true)
      },
      submitData () {
        this.$ga.event('folder', 'edit', this.folderId, 1)
        this.$http.put(
          '/api/folder/' + this.folderId,
          {
            name: this.folderName,
            description: this.folderDescription,
            issues: this.folderSelectedIssues,
            parent_folder_id: this.folder.parent_folder_id
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Folder edited successfully',
            type: 'success',
            close: 'auto'
          })
          this.loading = false
          this.setTheState()
          this.$refs.editfoldermodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem editing your folder: ${errorString}`,
            type: 'error',
            close: 'auto'
          })
          this.loading = false
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// EditFolderModal.vue?19c320a0